import { useState, useEffect } from "react";
import { getDocs, collection } from "firebase/firestore";
import { merge } from "lodash";
import ReactApexChart from "react-apexcharts";
import { Card, CardHeader, Box } from "@mui/material";
import { BaseOptionChart } from "../../../components/charts";
import { db } from "../../../firebase";

export default function AppConversionRates() {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "conversionRates"));
        const conversionRates = querySnapshot.docs.map(doc => doc.data().value);
        setData(conversionRates);
      } catch (error) {
        console.error("Error fetching conversion rates:", error);
      }
    };

    fetchData();
  }, []);

  const chartData = [
    {
      name: "Conversion Rate",
      data,
    },
  ];

  const chartOptions = merge(BaseOptionChart(), {
    xaxis: {
      categories: ["January", "February", "March", "April", "May", "June", "July"],
    },
  });

  return (
    <Card>
      <CardHeader title="Conversion Rates" />
      <Box sx={{ p: 3, pb: 1 }} dir="ltr">
        <ReactApexChart type="bar" series={chartData} options={chartOptions} height={364} />
      </Box>
    </Card>
  );
}
